import React from "react";
import { useTheme } from "../context/ThemeContext";

const Ellipse = ({ text, size = 150, stroke = 15 }) => {
    const { currentTheme } = useTheme();
    
    // Create unique gradient ID to avoid conflicts when multiple ellipses are rendered
    const gradientId = `gradient-${currentTheme}-${size}`;
    
    return (
        <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id={gradientId} x1="50%" y1="100%" x2="0%" y2="0%">
                    <stop offset="0%" stopColor="var(--secColor1)" />
                    <stop offset="76%" stopColor="var(--primaryColor)" />
                </linearGradient>
            </defs>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={size / 2 - 10}
                fill="none"
                stroke={`url(#${gradientId})`}
                strokeWidth={stroke}
            />
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dy=".3em"
                fontSize="40"
                fill="var(--textPrimary)"
                fontWeight="bold"
            >
                {text}
            </text>
        </svg>
    );
};

export default Ellipse;
